module.exports = __webpack_public_path__ + "0e66c9008c62d6105caa25ae9f3eef68.png";